<template>
  <div id="register">
    <v-card max-width="400px">
      <v-card-title>Register</v-card-title>
      <v-card-text class="pb-0">
        <v-text-field outlined dense :error-messages="emailError" label="Email" type="email" v-model="email"></v-text-field>
        <v-text-field outlined dense :error-messages="passwordError" label="Password" type="password" v-model="password"></v-text-field>
        <v-text-field outlined dense :error-messages="passwordError2" label="Re-type Password" type="password" v-model="password2"></v-text-field>
        <v-sheet class="title">Enter User Details</v-sheet>
        <v-divider class="mt-2 mb-4"></v-divider>
        <v-text-field outlined dense :error-messages="fnameError" label="First Name" type="text" v-model="fname"></v-text-field>
        <v-text-field outlined dense :error-messages="lnameError" label="Last Name" type="text" v-model="lname"></v-text-field>
      </v-card-text>
      <v-card-actions class="d-flex justify-space-between px-6">
        <v-btn small text color="secondary" to="/login" replace>Cancel</v-btn>
        <v-btn outlined color="primary" @click="submitForm">Register</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import {fa, db} from '@/db'

export default {
  name: 'Register',
  data() {
    return {
      email: null,
      password: null,
      password2: null,
      fname: null,
      lname: null,
      emailError: null,
      passwordError: null,
      passwordError2: null,
      fnameError: null,
      lnameError: null,
    }
  },
  computed: {
    
  },
  methods: {
    submitForm() {
      this.emailError = (!this.emailIsValid()) ? 'Invalid email address' : null
      this.passwordError = (!this.passwordIsValid()) ? 'Password must be at least 6 characters' : null
      this.passwordError2 = (this.password != this.password2) ? 'Passwords do not match' : null
      this.fnameError = (!this.fname) ? 'First Name cannot be blank' : null
      this.lnameError = (!this.lname) ? 'Last Name cannot be blank' : null
      if (!this.emailError && !this.passwordError && !this.passwordError2 && !this.fnameError && !this.lnameError) {
        fa.createUserWithEmailAndPassword(this.email, this.password).then((cred) => {
          console.log(cred.user);
          let u = { firstName: this.fname, lastName: this.lname }
          db.collection('users').doc(cred.user.uid).set(u, {merge: true}).then(() => this.$store.dispatch('setUser', u))
          this.$router.replace("/")
        }).catch(error => {
          this.$store.dispatch('setSnack', error.message)
        })
      }
    },
    emailIsValid() {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)
    },
    passwordIsValid() {
      return (!this.password || this.password.length < 6) ? false : true
    }
  }

}
</script>

<style>

</style>